import React, { useEffect, useRef, useState } from 'react';
import { Check } from 'lucide-react';

const PerfectForYouIf = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  const sectionRef = useRef(null);
  const itemRefs = useRef([]);
  const ctaRef = useRef(null);

  useEffect(() => {
    const headerObs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisibleItems(p => [...new Set([...p, 'header'])]); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) headerObs.observe(sectionRef.current);

    const itemObs = itemRefs.current.map((ref, i) => {
      const obs = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) setTimeout(() => setVisibleItems(p => [...new Set([...p, i])]), i * 80);
        },
        { threshold: 0.1 }
      );
      if (ref) obs.observe(ref);
      return obs;
    });

    const ctaObs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisibleItems(p => [...new Set([...p, 'cta'])]); },
      { threshold: 0.1 }
    );
    if (ctaRef.current) ctaObs.observe(ctaRef.current);

    return () => { headerObs.disconnect(); itemObs.forEach(o => o.disconnect()); ctaObs.disconnect(); };
  }, []);

  const criteria = [
    "You have an engaged audience but struggle to monetize effectively",
    "You're creating great content but don't have time for the business side",
    "You want to create digital products but don't know where to start",
    "You're ready to invest in your business growth with a proven partner",
    "You have valuable knowledge and want to package it into scalable products",
    "You're tired of trading time for money and want passive income streams",
    "You want to build a real business, not just a social media presence",
    "You're committed to long-term growth and willing to trust the process"
  ];

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-[rgb(26,28,30)] relative overflow-hidden">
      <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-[rgba(124,56,178,0.05)] blur-[120px] rounded-full pointer-events-none"></div>

      <div className="max-w-[1000px] mx-auto relative z-10">
        <div className={`text-center mb-12 transition-all duration-700 ${
          visibleItems.includes('header') ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-10 scale-95'
        }`}>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            This Is <span className="bg-gradient-to-r from-[rgb(197,155,47)] to-[rgb(224,194,95)] text-transparent bg-clip-text">Perfect For You</span> If...
          </h2>
          <p className="text-xl text-[rgb(218,218,218)]">
            You're ready to take your content business to the next level
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {criteria.map((item, index) => {
            const fromLeft = index % 2 === 0;
            return (
              <div
                key={index}
                ref={el => (itemRefs.current[index] = el)}
                className={`flex items-start space-x-3 bg-[rgb(38,40,42)] border border-[rgba(255,255,255,0.1)] rounded-xl p-5 hover:border-[rgb(197,155,47)] hover:bg-[rgba(197,155,47,0.05)] hover:shadow-[0_4px_20px_rgba(197,155,47,0.1)] transition-all duration-300 hover:-translate-y-1 ${
                  visibleItems.includes(index)
                    ? 'opacity-100 translate-x-0'
                    : fromLeft ? 'opacity-0 -translate-x-8' : 'opacity-0 translate-x-8'
                }`}
              >
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-br from-[rgba(197,155,47,0.3)] to-[rgba(124,56,178,0.3)] border border-[rgb(197,155,47)] flex items-center justify-center mt-0.5">
                  <Check size={14} className="text-[rgb(197,155,47)]" />
                </div>
                <p className="text-[rgb(218,218,218)] leading-relaxed">
                  {item}
                </p>
              </div>
            );
          })}
        </div>

        <div ref={ctaRef} className={`mt-12 text-center transition-all duration-700 ${
          visibleItems.includes('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <p className="text-2xl font-semibold text-white mb-4">
            If you checked most of these boxes, <span className="text-[rgb(197,155,47)]">let's talk</span>
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gradient-to-r from-[rgb(197,155,47)] to-[rgb(224,194,95)] text-[rgb(17,17,19)] px-8 py-4 rounded-xl font-semibold text-lg hover:from-[rgb(224,194,95)] hover:to-[rgb(197,155,47)] transition-all duration-300 hover:transform hover:scale-105 shadow-[0_0_30px_rgba(197,155,47,0.4)] hover:shadow-[0_0_50px_rgba(197,155,47,0.6)]"
          >
            Start Your Journey
          </button>
        </div>
      </div>
    </section>
  );
};

export default PerfectForYouIf;